export default __webpack_public_path__ + "static/media/vineyard.cb643746.png";